import {
  DEVICE_ATTACH_INIT,
  DEVICE_ATTACH_SUCCESS,
  DEVICE_ATTACH_ERROR,
} from '../../actions/tracking/constants';

const initState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case DEVICE_ATTACH_INIT:
      return { ...state, loading: true, data: null, error: null };
    case DEVICE_ATTACH_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case DEVICE_ATTACH_ERROR:
      return { ...state, loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};
